<template>
  <THead class="bg-slate-50 text-slate-600">
    <Tr>
      <Th
        class="border-bottom-0"
        v-if="hasFavourites"
        data-id="has-favourites"
      />
      <Th
        class="border-bottom-0 text-sm font-medium"
        v-if="hasSlot"
        data-id="has-slot"
      />
      <Th
        class="border-bottom-0 text-sm font-medium"
        v-for="(field, i) in fields"
        :key="i"
      >
        <span class="flex flex-nowrap gap-0.5">
          <span>
            {{ field.label }}
          </span>
          <button
            class="is-pointer"
            v-if="field.sortable"
            type="button"
            data-sortable
            :data-sort-value="sort"
            data-id="table-header-sort-trigger"
            tabindex="0"
            @click="onSortChange"
            @keydown.enter="onSortChange"
            @keydown.space="onSortChange"
          >
            <span v-if="sort === 'DESC'" data-id="sort-state-desc"
              ><Icon icon="chevronDown"
            /></span>
            <span v-if="sort === 'ASC'" data-id="sort-state-asc"
              ><Icon icon="chevronUp"
            /></span>
          </button>
        </span>
      </Th>
      <Th
        class="border-bottom-0 text-right text-sm font-medium"
        v-if="hasActions"
      >
        Actions
      </Th>
    </Tr>
  </THead>
</template>
<script setup lang="ts" generic="T">
import Icon from '../../../components/form/Icon.vue';
import type { Field } from '../../../lib/services/helpers';
import THead from '../../../components/table/parts/THead.vue';
import Tr from '../../../components/table/parts/Tr.vue';
import Th from '../../../components/table/parts/Th.vue';

const props = withDefaults(
  defineProps<{
    fields: Field<T>[];
    sort?: 'DESC' | 'ASC';
    hasFavourites?: boolean;
    hasSlot?: boolean;
    hasActions?: boolean;
  }>(),
  {
    sort: 'DESC',
  },
);
const emit = defineEmits<{ (e: 'sort', p: 'DESC' | 'ASC'): void }>();

const onSortChange = () => {
  emit('sort', props.sort === 'DESC' ? 'ASC' : 'DESC');
};
</script>
